<div class="content-wrapper container-xxl p-0">
  <div class="content-body">
    <!-- content-header component -->
    <app-content-header [contentHeader]="contentHeader"></app-content-header>

    <!-- Basic Alerts start -->
    <section id="home-page">
      <div class="row match-height">
        <!-- Medal Card -->
        <div class="col-xl-4 col-md-6 col-12">
            <div class="card card-congratulation-medal">
                <div class="card-body">
                    <h4 class="mt-75">المبيعات الشهرية</h4>
                    <p class="card-text font-small-3">اجمالى مبيعات الشهر</p>
                    <h3 class="mb-75 mt-2 pt-50">
                        <a href="#">{{totalPayment}} SAR</a>
                    </h3>
                    <div class="dollar-div">
                        <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M15.0007 8.33325H11.6673C9.82637 8.33325 8.33398 9.82564 8.33398 11.6666V31.6666C8.33398 33.5075 9.82637 34.9999 11.6673 34.9999H28.334C30.1749 34.9999 31.6673 33.5075 31.6673 31.6666V11.6666C31.6673 9.82564 30.1749 8.33325 28.334 8.33325H25.0007" stroke="#24B364" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                            <rect x="15" y="5" width="10" height="6.66667" rx="2" stroke="#24B364" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                            <path d="M23.3327 18.3333H19.166C17.7853 18.3333 16.666 19.4525 16.666 20.8333C16.666 22.214 17.7853 23.3333 19.166 23.3333H20.8327C22.2134 23.3333 23.3327 24.4525 23.3327 25.8333C23.3327 27.214 22.2134 28.3333 20.8327 28.3333H16.666" stroke="#24B364" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                            <path d="M20.7493 28.3334C20.7493 27.9192 20.4136 27.5834 19.9993 27.5834C19.5851 27.5834 19.2493 27.9192 19.2493 28.3334H20.7493ZM19.2493 30.0001C19.2493 30.4143 19.5851 30.7501 19.9993 30.7501C20.4136 30.7501 20.7493 30.4143 20.7493 30.0001H19.2493ZM20.7493 16.6667C20.7493 16.2525 20.4136 15.9167 19.9993 15.9167C19.5851 15.9167 19.2493 16.2525 19.2493 16.6667H20.7493ZM19.2493 18.3334C19.2493 18.7476 19.5851 19.0834 19.9993 19.0834C20.4136 19.0834 20.7493 18.7476 20.7493 18.3334H19.2493ZM19.2493 28.3334V30.0001H20.7493V28.3334H19.2493ZM19.2493 16.6667V18.3334H20.7493V16.6667H19.2493Z" fill="#24B364"/>
                        </svg>                            
                    </div>
                </div>
            </div>
        </div>
        <!--/ Medal Card -->

        <!-- Statistics Card -->
        <div class="col-xl-8 col-md-6 col-12">
            <div class="card card-statistics">
                <div class="card-header">
                    <h4 class="card-title">إحصائيات الشهر الماضى</h4>
                    <div class="d-flex align-items-center">
                        <!-- <p class="card-text font-small-3 me-25 mb-0">منذ 24 يوم</p> -->
                    </div>
                </div>
                <div class="card-body statistics-body">
                    <div class="row">
                        <div class="col-xl-3 col-sm-6 col-12 mb-2 mb-xl-0">
                            <div class="d-flex flex-row">
                                <div class="avatar bg-light-primary mr-1">
                                    <div class="avatar-content">
                                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M15 5V7" stroke="#3F8260" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                            <path d="M15 11V13" stroke="#3F8260" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                            <path d="M15 17V19" stroke="#3F8260" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                            <path d="M5 5H19C20.1046 5 21 5.89543 21 7V10C19.8954 10 19 10.8954 19 12C19 13.1046 19.8954 14 21 14V17C21 18.1046 20.1046 19 19 19H5C3.89543 19 3 18.1046 3 17V14C4.10457 14 5 13.1046 5 12C5 10.8954 4.10457 10 3 10V7C3 5.89543 3.89543 5 5 5" stroke="#3F8260" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                        </svg>
                                    </div>
                                </div>
                                <div class="my-auto">
                                    <h4 class="fw-bolder mb-0">{{totalTicketsSold}}</h4>
                                    <p class="card-text font-small-3 mb-0">التذاكر المباعة</p>
                                </div>
                            </div>
                        </div>
                        <div class="col-xl-3 col-sm-6 col-12 mb-2 mb-xl-0">
                            <div class="d-flex flex-row">
                                <div class="avatar bg-light-info mr-1">
                                    <div class="avatar-content">
                                        <!-- <i data-feather="user" class="avatar-icon"></i> -->
                                        <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <circle cx="9.5" cy="7" r="4" stroke="#00BAD1" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                            <path d="M3.5 21V19C3.5 16.7909 5.29086 15 7.5 15H11.5C13.7091 15 15.5 16.7909 15.5 19V21" stroke="#00BAD1" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                            <path d="M16.5 3.12988C18.2699 3.58305 19.5078 5.17787 19.5078 7.00488C19.5078 8.83189 18.2699 10.4267 16.5 10.8799" stroke="#00BAD1" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                            <path d="M21.5 20.9999V18.9999C21.4896 17.1845 20.2578 15.6037 18.5 15.1499" stroke="#00BAD1" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                        </svg>                                            
                                    </div>
                                </div>
                                <div class="my-auto">
                                    <h4 class="fw-bolder mb-0">{{totalUsers}}</h4>
                                    <p class="card-text font-small-3 mb-0">مستخدمين جدد</p>
                                </div>
                            </div>
                        </div>
                        <div class="col-xl-3 col-sm-6 col-12 mb-2 mb-sm-0">
                            <div class="d-flex flex-row">
                                <div class="avatar bg-light-success mr-1">
                                    <div class="avatar-content">
                                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <rect x="4" y="5" width="16" height="16" rx="2" stroke="#28C76F" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                            <path d="M16 3V7" stroke="#28C76F" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                            <path d="M8 3V7" stroke="#28C76F" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                            <path d="M4 11H20" stroke="#28C76F" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                            <rect x="8" y="15" width="2" height="2" stroke="#28C76F" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                        </svg>                                            
                                        <!-- <i data-feather="box" class="avatar-icon"></i> -->
                                    </div>
                                </div>
                                <div class="my-auto">
                                    <h4 class="fw-bolder mb-0">{{totalEvents}}</h4>
                                    <p class="card-text font-small-3 mb-0">فعالية تم تنظيمه</p>
                                </div>
                            </div>
                        </div>
                        <div class="col-xl-3 col-sm-6 col-12">
                            <div class="d-flex flex-row">
                                <div class="avatar bg-light-danger mr-1">
                                    <div class="avatar-content">
                                        <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <circle cx="12.5" cy="12" r="9" stroke="#FF4C51" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                            <path d="M7.5 8.5L10.5 11.5" stroke="#FF4C51" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                            <path d="M7.5 11.5L10.5 8.5" stroke="#FF4C51" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                            <path d="M14.5 8.5L17.5 11.5" stroke="#FF4C51" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                            <path d="M14.5 11.5L17.5 8.5" stroke="#FF4C51" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                            <path d="M10 15C10.6583 15.6719 11.5594 16.0505 12.5 16.0505C13.4406 16.0505 14.3417 15.6719 15 15" stroke="#FF4C51" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                        </svg>                                            
                                        <!-- <i data-feather="dollar-sign" class="avatar-icon"></i> -->
                                    </div>
                                </div>
                                <div class="my-auto">
                                    <h4 class="fw-bolder mb-0">{{totalOrganizers}}</h4>
                                    <p class="card-text font-small-3 mb-0">مشرفين جدد</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!--/ Statistics Card -->
    </div>
    <div class="row match-height">
      <div class="col-lg-4 col-12">
          <div class="row match-height">
              <!-- Earnings Card -->
              <div class="col-lg-12 col-md-6 col-12">
                  <div class="card earnings-card">
                    <div class="card-body">
                        <h4 class="mt-75">نظرة عامة على التذاكر</h4>
                        <p class="card-text font-small-3">إجمالى حالات التذاكر للأحداث الجارية</p>
                        <h3 class="mb-75 mt-2 pt-50">
                            <a class="total-tickets-number">{{purchasedTickets + availableTickets}}</a>
                            <p class="card-text font-small-3">اجمالي التذاكر</p>
                        </h3>

                        <div class="tickets-avatar mt-3">
                            <div class="d-flex flex-row">
                                <div class="avatar bg-light-primary mr-1">
                                    <div class="avatar-content">
                                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M15 5V7" stroke="#3F8260" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                            <path d="M15 11V13" stroke="#3F8260" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                            <path d="M15 17V19" stroke="#3F8260" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                            <path d="M5 5H19C20.1046 5 21 5.89543 21 7V10C19.8954 10 19 10.8954 19 12C19 13.1046 19.8954 14 21 14V17C21 18.1046 20.1046 19 19 19H5C3.89543 19 3 18.1046 3 17V14C4.10457 14 5 13.1046 5 12C5 10.8954 4.10457 10 3 10V7C3 5.89543 3.89543 5 5 5" stroke="#3F8260" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                        </svg>
                                    </div>
                                </div>
                                <div class="my-auto">
                                    <h4 class="fw-bolder mb-0">التذاكر المباعة</h4>
                                    <p class="card-text font-small-3 mb-0">{{purchasedTickets}} تذكرة</p>
                                </div>
                            </div>
                        </div>

                        <div class="tickets-avatar mt-2">
                            <div class="d-flex flex-row">
                                <div class="avatar bg-light-orange mr-1">
                                    <!-- <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <circle cx="11" cy="11" r="8.25" stroke="#FF9F43" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                        <path d="M11 6.41675V11.0001L13.75 13.7501" stroke="#FF9F43" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                    </svg>-->
                                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M15 5V7" stroke="#FF9F43" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                        <path d="M15 11V13" stroke="#FF9F43" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                        <path d="M15 17V19" stroke="#FF9F43" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                        <path d="M5 5H19C20.1046 5 21 5.89543 21 7V10C19.8954 10 19 10.8954 19 12C19 13.1046 19.8954 14 21 14V17C21 18.1046 20.1046 19 19 19H5C3.89543 19 3 18.1046 3 17V14C4.10457 14 5 13.1046 5 12C5 10.8954 4.10457 10 3 10V7C3 5.89543 3.89543 5 5 5" stroke="#FF9F43" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                    </svg>
                                </div>
                                <div class="my-auto">
                                    <h4 class="fw-bolder mb-0">التذاكر المتبقية</h4>
                                    <p class="card-text font-small-3 mb-0">{{availableTickets}} تذكرة</p>
                                </div>
                            </div>
                        </div>

                        <div class="mt-3">
                            <div id="donut-chart" #apexDonutChartRef *ngIf="apexDonutChart.series">
                                <apx-chart
                                    [series]="apexDonutChart.series"
                                    [chart]="{
                                    height: 350,
                                    width: isMenuToggled === false ? apexDonutChartRef?.offsetWidth : apexDonutChart?.chart?.width,
                                    type: 'donut'
                                    }"
                                    [labels]="apexDonutChart?.labels"
                                    [plotOptions]="apexDonutChart?.plotOptions"
                                    [responsive]="apexDonutChart?.responsive"
                                    [colors]="apexDonutChart?.colors"
                                    [legend]="apexDonutChart?.legend"
                                ></apx-chart>
                            </div>
                        </div>
                    </div>
                      <!-- <div class="card-body">
                          <div class="row">
                              <div class="col-6">
                                  <h4 class="card-title mb-1">Earnings</h4>
                                  <div class="font-small-2">This Month</div>
                                  <h5 class="mb-1">$4055.56</h5>
                                  <p class="card-text text-muted font-small-2">
                                      <span class="fw-bolder">68.2%</span><span> more earnings than last month.</span>
                                  </p>
                              </div>
                              <div class="col-6">
                                  
                              </div>
                          </div>
                      </div> -->
                  </div>
              </div>
              <!--/ Earnings Card -->
          </div>
      </div>

      <!-- Revenue Report Card -->
      <div class="col-lg-8 col-12">
          <div class="card card-revenue-budget">
              <div class="row mx-0">
                  <div class="col-md-12 col-12 revenue-report-wrapper">
                    <div class="card-body pt-1">
                        <h4 class="">إحصائيات عامة</h4>
                        <p class="card-text font-small-3">تعرف على إحصائيات السنة</p>

                        <app-tabs  (tabChanged)="onTabChange($event)">
                            <app-tab title="المبيعات" [svgIcon]="salesIcon" [active]="true"></app-tab>
                            <app-tab title="التذاكر" [svgIcon]="ticketsIcon"></app-tab>
                            <app-tab title="المستخدمين" [svgIcon]="usersIcon"></app-tab>
                            <app-tab title="الأحداث" [svgIcon]="calendarIcon"></app-tab>
                        </app-tabs>
                        
                        <div id="column-chart" *ngIf="apexColumnChart?.series && apexColumnChart?.xaxis">
                            <apx-chart 
                                #apexColumnChartRef
                                [series]="apexColumnChart?.series || []"
                                [chart]="{
                                type: 'bar',
                                height: 400,
                                width: isMenuToggled === false ? '100%' : '100%',
                                stacked: true,
                                toolbar: {
                                    show: false
                                }
                                }"
                                [xaxis]="apexColumnChart?.xaxis"
                                [stroke]="apexColumnChart?.stroke"
                                [tooltip]="apexColumnChart?.tooltip"
                                [colors]="apexColumnChart?.colors"
                                [legend]="apexColumnChart?.legend"
                                [dataLabels]="apexColumnChart?.dataLabels"
                                [plotOptions]="apexColumnChart?.plotOptions"
                                [grid]="apexColumnChart?.grid"
                            ></apx-chart>
                        </div>
                    </div>
                  </div>
              </div>
          </div>
      </div>
      <!--/ Revenue Report Card -->
  </div>
      <div class="row">
        <div class="col-12">
          <div class="card">
            <div class="card-header mb-2" style="border-bottom: 1px solid lightgray;">
              <h4 class="card-title">اخر الطلبات</h4>
            </div>
            <div class="card-body pb-1">
                <div class="card-datatable text-nowrap">
                    <div class="row mb-2">
                        <!-- <div class="col-md-6">
                            <div class="">
                                <ng-select [items]="paymentStatus" bindLabel="paymentStatus" bindValue="paymentStatus" [placeholder]="'حالة الدفع'">
                                    <ng-template ng-optgroup-tmp let-item="item">
                                        {{ item.paymentStatus || 'Unnamed group' }}
                                    </ng-template>
                                </ng-select>
                            </div>
                        </div> -->
                        <!-- <div class="col-md-6">
                            <div class="">
                                <ng-select [items]="paymentWay" bindLabel="paymentWay" bindValue="paymentWay" [placeholder]="'وسيلة الدفع'">
                                    <ng-template ng-optgroup-tmp let-item="item">
                                        {{ item.paymentWay || 'Unnamed group' }}
                                    </ng-template>
                                </ng-select>
                            </div>
                        </div> -->
                        <!-- <div class="col-12" style="text-align: end;margin-top: 10px;">
                            <button class="btn btn-outline-primary waves-effect">
                                <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <circle cx="10" cy="10.5867" r="7" stroke="#2F2B3D" stroke-opacity="0.9" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                    <path d="M21 21.5867L15 15.5867" stroke="#2F2B3D" stroke-opacity="0.9" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                </svg>
                                <span>بحث</span>
                            </button>
                        </div> -->
                    </div>
                    <!-- <hr> -->
                    <div class="d-flex mb-3" style="align-items: center;justify-content: space-between;">
                        <div class="input-group input-group-merge w-auto">
                            <input type="text" id="first-name-icon" class="form-control" name="fname-icon" placeholder="ابحث فى اخر الطلبات" (keyup)="updateFilter($event)">
                            <span class="input-group-text">
                                <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <circle cx="10" cy="10.5867" r="7" stroke="#2F2B3D" stroke-opacity="0.9" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                    <path d="M21 21.5867L15 15.5867" stroke="#2F2B3D" stroke-opacity="0.9" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                </svg>
                            </span>
                        </div>
                        <!-- <input type="text" style="padding:8px;width:30%;" placeholder="ابحث فى المستخدمين" (keyup)="updateFilter($event)"/> -->
                        <div class="d-flex">
                            <select id="per-page" class="form-control pl-3 pr-0" (change)="onLimitChange($event.target.value)">
                              <option *ngFor="let option of pageLimitOptions" [value]="option.value" [selected]="option.value == currentPageLimit">
                                {{ option.value }}
                              </option>
                            </select>
                            <!-- <button class="btn btn-outline-primary waves-effect py-0 ml-2" type="button" (click)="modalOpenDefault(modalDefault)" rippleEffect>
                                <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M2.66602 11.9199V13.2533C2.66602 13.9896 3.26297 14.5866 3.99935 14.5866H11.9993C12.7357 14.5866 13.3327 13.9896 13.3327 13.2533V11.9199" stroke="#3F8260" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                    <path d="M4.66602 6.58675L7.99935 3.25342L11.3327 6.58675" stroke="#3F8260" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                    <path d="M7.99935 3.25342V11.2534" stroke="#3F8260" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                </svg>                                    
                                <span class="pl-1">استخراج</span>
                            </button> -->

                            <!-- <div class="modal-size-default d-inline-block">
                                <ng-template #modalDefault let-modal>
                                  <div class="modal-header">
                                    <h5 class="modal-title" id="myModalLabel160"></h5>
                                    <button type="button" class="close" (click)="modal.dismiss('Cross click')" aria-label="Close" title="إغلاق">
                                      <span aria-hidden="true">&times;</span>
                                    </button>
                                  </div>
                                  <div class="modal-body text-center" tabindex="0" ngbAutofocus>
                                    <h4>استخراج ملف</h4>
                                    <p class="pt-1">اضغط على احدى الصيغ الاتية لبدء التحميل</p>
                                    <div class="d-flex mt-2" style="justify-content: center;">
                                        <button class="btn btn-outline-primary waves-effect ml-1" rippleEffect (click)="downloadFile('pdf');modal.close('Accept click')">
                                            <p class="mb-50">
                                                <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <g clip-path="url(#clip0_5021_101245)">
                                                        <path d="M20.616 5.54L17.126 2.05C15.806 0.73 14.046 0 12.176 0H7.66602C4.90602 0 2.66602 2.24 2.66602 5V19C2.66602 21.76 4.90602 24 7.66602 24H17.666C20.426 24 22.666 21.76 22.666 19V10.49C22.666 8.62 21.936 6.86 20.616 5.54ZM19.206 6.95C19.526 7.27 19.796 7.62 20.016 8H15.676C15.126 8 14.676 7.55 14.676 7V2.66C15.056 2.88 15.406 3.15 15.726 3.47L19.216 6.96L19.206 6.95ZM20.666 19C20.666 20.65 19.316 22 17.666 22H7.66602C6.01602 22 4.66602 20.65 4.66602 19V5C4.66602 3.35 6.01602 2 7.66602 2H12.176C12.336 2 12.506 2 12.666 2.02V7C12.666 8.65 14.016 10 15.666 10H20.646C20.666 10.16 20.666 10.32 20.666 10.49V19ZM7.75602 13H6.66602C6.11602 13 5.66602 13.45 5.66602 14V18.44C5.66602 18.79 5.94602 19.06 6.28602 19.06C6.62602 19.06 6.90602 18.78 6.90602 18.44V17.22H7.74602C8.92602 17.22 9.88602 16.27 9.88602 15.11C9.88602 13.95 8.92602 13 7.74602 13H7.75602ZM7.75602 15.97H6.92602V14.25H7.76602C8.24602 14.25 8.65602 14.64 8.65602 15.11C8.65602 15.58 8.24602 15.97 7.76602 15.97H7.75602ZM19.686 13.63C19.686 13.98 19.406 14.25 19.066 14.25H17.376V15.39H18.616C18.966 15.39 19.236 15.67 19.236 16.01C19.236 16.35 18.956 16.63 18.616 16.63H17.376V18.43C17.376 18.78 17.096 19.05 16.756 19.05C16.416 19.05 16.136 18.77 16.136 18.43V13.62C16.136 13.27 16.416 13 16.756 13H19.066C19.416 13 19.686 13.28 19.686 13.62V13.63ZM12.756 13.01H11.666C11.116 13.01 10.666 13.46 10.666 14.01V18.45C10.666 18.8 10.946 19.01 11.286 19.01C11.626 19.01 12.746 19.01 12.746 19.01C13.926 19.01 14.886 18.06 14.886 16.9V15.12C14.886 13.96 13.926 13.01 12.746 13.01H12.756ZM13.646 16.9C13.646 17.37 13.236 17.76 12.756 17.76H11.926V14.26H12.766C13.246 14.26 13.656 14.65 13.656 15.12V16.9H13.646Z" fill="#2F2B3D" fill-opacity="0.9"/>
                                                    </g>
                                                    <defs>
                                                        <clipPath id="clip0_5021_101245">
                                                            <rect width="24" height="24" fill="white" transform="translate(0.666016)"/>
                                                        </clipPath>
                                                    </defs>
                                                </svg>
                                            </p>
                                            <p class="mb-1 file-name">PDF</p>
                                            <p class="mb-50 download">اضغط للتحميل</p>
                                        </button>
                                        <button class="btn btn-outline-primary waves-effect" rippleEffect (click)="downloadFile('excel');modal.close('Accept click')">
                                            <p class="mb-50">
                                                <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <g clip-path="url(#clip0_5021_101257)">
                                                        <path d="M15.602 13.64L13.632 16L15.602 18.36C15.952 18.78 15.902 19.41 15.472 19.77C15.282 19.93 15.062 20 14.832 20C14.542 20 14.262 19.88 14.062 19.64L12.332 17.56L10.602 19.64C10.402 19.88 10.122 20 9.83203 20C9.60203 20 9.38203 19.92 9.19203 19.77C8.77203 19.42 8.71203 18.79 9.06203 18.36L11.032 16L9.06203 13.64C8.71203 13.22 8.76203 12.59 9.19203 12.23C9.62203 11.88 10.242 11.93 10.602 12.36L12.332 14.44L14.062 12.36C14.412 11.94 15.042 11.88 15.472 12.23C15.892 12.58 15.952 13.21 15.602 13.64ZM22.332 10.49V19C22.332 21.76 20.092 24 17.332 24H7.33203C4.57203 24 2.33203 21.76 2.33203 19V5C2.33203 2.24 4.57203 0 7.33203 0H11.842C13.712 0 15.472 0.73 16.792 2.05L20.272 5.54C21.592 6.86 22.322 8.62 22.322 10.49H22.332ZM15.382 3.46C15.062 3.14 14.712 2.87 14.332 2.65V7C14.332 7.55 14.782 8 15.332 8H19.672C19.452 7.62 19.182 7.27 18.862 6.95L15.382 3.46ZM20.332 10.48C20.332 10.32 20.332 10.15 20.312 9.99H15.332C13.682 9.99 12.332 8.64 12.332 6.99V2.02C12.172 2 12.012 2 11.842 2H7.33203C5.68203 2 4.33203 3.35 4.33203 5V19C4.33203 20.65 5.68203 22 7.33203 22H17.332C18.982 22 20.332 20.65 20.332 19V10.49V10.48Z" fill="#2F2B3D" fill-opacity="0.9"/>
                                                    </g>
                                                    <defs>
                                                        <clipPath id="clip0_5021_101257">
                                                            <rect width="24" height="24" fill="white" transform="translate(0.332031)"/>
                                                        </clipPath>
                                                    </defs>
                                                </svg>                                                
                                            </p>
                                            <p class="mb-1 file-name">Excel</p>
                                            <p class="mb-50 download">اضغط للتحميل</p>
                                        </button>
                                    </div>
                                    <p class="note mt-2 mb-4">ملحوظة : البيانات المستخرجة ستتطابق مع التصفية الحالية</p>
                                  </div>
                                </ng-template>
                              </div> -->
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-12 text-left mb-2">
                            <button class="btn btn-outline-primary waves-effect ml-2" type="button" rippleEffect (click)="export()"> 
                                <span class="pr-1">Excel</span>
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="17" height="17" class="main-grid-item-icon" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2">
                                    <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
                                    <polyline points="7 10 12 15 17 10" />
                                    <line x1="12" x2="12" y1="15" y2="3" />
                                </svg>
                            </button>
                        </div>
                    </div>
                    <div class="table-responsive home-table">
                    

                    <ngx-datatable
                            #table
                            id="ngxTable"
                            class="material bootstrap core-bootstrap"
                            [rows]="rows"
                            [columnMode]="'force'"
                            [headerHeight]="40"
                            [footerHeight]="50"
                            [limit]="10"
                            [rowHeight]="'auto'"
                            [scrollbarH]="true"
                            [selectAllRowsOnPage]="true"
                          >
                            <ngx-datatable-column
                              [width]="50"
                              [sortable]="false"
                              [canAutoResize]="false"
                              [draggable]="false"
                              [resizeable]="false"
                            >
                              <ng-template
                                ngx-datatable-header-template
                                let-value="value"
                                let-allRowsSelected="allRowsSelected"
                                let-selectFn="selectFn"
                              >
                                <div class="custom-control custom-control-primary custom-checkbox">
                                  <input
                                    type="checkbox"
                                    class="custom-control-input"
                                    [checked]="allRowsSelected"
                                    (change)="selectFn(!allRowsSelected)"
                                    id="headerCustomChkbxRef"
                                  />
                                  <label class="custom-control-label" for="headerCustomChkbxRef"></label>
                                </div>
                              </ng-template>
                              <ng-template
                                ngx-datatable-cell-template
                                let-rowIndex="rowIndex"
                                let-value="value"
                                let-isSelected="isSelected"
                                let-onCheckboxChangeFn="onCheckboxChangeFn"
                              >
                                <div class="custom-control custom-control-primary custom-checkbox">
                                  <input
                                    type="checkbox"
                                    class="custom-control-input"
                                    [checked]="isSelected"
                                    (change)="onCheckboxChangeFn($event)"
                                    id="rowCustomChkbxRef{{ rowIndex }}"
                                  />
                                  <label class="custom-control-label" for="rowCustomChkbxRef{{ rowIndex }}"></label>
                                </div>
                              </ng-template>
                            </ngx-datatable-column>
                            <ngx-datatable-column name="#" prop="#" [width]="30"></ngx-datatable-column>
                            <ngx-datatable-column name="اسم المستخدم" prop="userName"></ngx-datatable-column>
                            <ngx-datatable-column name="الفعالية" prop="eventName"></ngx-datatable-column>
                            <ngx-datatable-column class="text-center" name="عدد التذاكر" prop="numberOfTickets"></ngx-datatable-column>
                            <ngx-datatable-column name="الإجمالى" prop="totalAmount"></ngx-datatable-column>
                            <ngx-datatable-column name="وسيلة الدفع" prop="paymentWay"></ngx-datatable-column>
                            <ngx-datatable-column name="حالة الدفع" prop="paymentStatus">
                              </ngx-datatable-column>
                            
                          </ngx-datatable>
                    </div>
                  </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!-- Basic Alerts end -->
  </div>
</div>
